import { render, staticRenderFns } from "./startClassRecordCourseDetail.vue?vue&type=template&id=7ab64b6a&scoped=true"
import script from "./startClassRecordCourseDetail.vue?vue&type=script&lang=js"
export * from "./startClassRecordCourseDetail.vue?vue&type=script&lang=js"
import style0 from "./startClassRecordCourseDetail.vue?vue&type=style&index=0&id=7ab64b6a&prod&lang=less&scoped=true"
import style1 from "./startClassRecordCourseDetail.vue?vue&type=style&index=1&id=7ab64b6a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ab64b6a",
  null
  
)

export default component.exports